//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmFooter from '@/components/cmFooter.vue'

export default {
  name: 'work',
  components: {
      cmFooter
  },
  data () {
    return {
      type:0,
      grade:0,
      count:[],
      service:{}
    }
  },
  created(){
    this.grade = parseInt(this.$func.getLocal('grade'));
  },
  mounted(){
    this.workCount();

  },
  methods:{
    workCount(){
      this.$api.workCount({}).then((res)=>{
        this.count = res.data;
        this.service = res.data.service;
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/work.vue